import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { QuestionGroupState } from '@proxy/question-groups';
import { EnumDescriptor } from '../../enum-descriptor';

@Component({
    selector: 'app-question-group-state-dropdown',
    templateUrl: './question-group-state-dropdown.component.html',
    standalone: false
})
export class QuestionGroupStateDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() questionGroupState: QuestionGroupState;

  @Output() changeQuestionGroupState = new EventEmitter<QuestionGroupState>();

  questionGroupStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.questionGroupStates)) {
      this.questionGroupState = QuestionGroupState.Active;
    }

    this.loadQuestionGroupState();
    this.onSelected();
  }

  loadQuestionGroupState(): void {
    this.questionGroupStates = this.getEnumOptions(QuestionGroupState, false);
  }

  onSelected(): void {
    this.changeQuestionGroupState.emit(this.questionGroupState);
  }
}
